import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "coins_refunds",
        object: "coins_refund",
        header: [
            { text: "ID", value: "id" },
            { text: "Usuario", value: "user", sortable: false },
            { text: "Coins", value: "coins", sortable: false },
            { text: "Comentarios", value: "comments", sortable: false },
            { text: "Fecha", value: "createdAt", sortable: false },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
